export { default as Message } from './Message';
export { default as Header } from './MessageHeader';
export { default as Body } from './MessageBody';


// WEBPACK FOOTER //
// ./src/components/Message/index.ts